<!--
  -- this component is using the new Vue Composition API, this is a step towards our goal
  -- of migrating helios into Vue3. To learn more about it, check:
  -- https://vuejs.org/api/composition-api-setup
  -- https://vuejs.org/guide/extras/composition-api-faq.html
-->
<template>
  <div class="wrapper">
    <label
      for="carrier-search-autocomplete"
      class="label"
      data-testid="carrier-search-autocomplete-label">
      <slot name="label">
        <v-icon size="small">mdi-plus</v-icon>
        {{ t('carrier.lists.carrierList.labels.addCarrierContactsToYourOrgsList') }}
      </slot>
    </label>

    <v-autocomplete
      flat
      variant="outlined"
      no-filter
      hide-details
      return-object
      id="carrier-search-autocomplete"
      data-testid="carrier-search-autocomplete"
      :placeholder="t('carrier.lists.carrierList.placeholders.searchByCarrierNameEmailOrCompany')"
      item-value="id"
      :item-title="item => `${item.firstName} ${item.lastName}`"
      @update:search="carriers.updateSearchInput"
      :model-value="null"
      :loading="carriers.isLoadingRef.value"
      :items="carriers.carriersRef.value">
      <template #item="{ item }">
        <carrier-contact-search-item :carrier="item.raw" role="option" />
      </template>
      <template #append-item>
        <v-divider></v-divider>
        <v-list-item @click="openCreateCarrierContactDialog">
          <v-list-item-title>
            <span class="typography-body-md mr-1">
              {{ t('carrier.lists.carrierList.messages.didntFindYourCarrierContact') }}
            </span>
            <span class="typography-body-md-bold">{{ t('customForms.buttons.createNew') }}</span>
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { emitCustomEvent } from '@/composables/useCustomEvent';
import useCarriers from '@/composables/useCarriers';
import useCarrierContacts from '@/composables/useCarrierContacts';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'CarrierContactSearch',
  props: {},
  setup() {
    const { t } = useI18n();
    const carriers = useCarriers({ prefetch: true });
    const carrierContacts = useCarrierContacts();

    const handleSave = async () => {
      await Promise.all([carriers.fetch(), carrierContacts.fetch()]);
    };

    const openCreateCarrierContactDialog = () => {
      emitCustomEvent('open-create-carrier-contact-dialog', {
        mixpanelEntryPoint: 'Carrier Contacts Select List',
        onContactCreated: handleSave
      });
    };

    return { carriers, handleSave, openCreateCarrierContactDialog, t };
  }
});
</script>

<style scoped lang="scss">
// TODO(2024-06-19): the styling breaks if we remove these imports,
// we need to investigate why they are not being imported by default.
//@import '~vuetify/src/styles/styles.sass';
@import '@satellite/styles/main';
@import '@/styles/partials/variables';

.wrapper {
  flex: 1;
}

.label {
  color: $color-neutral-90;
  font-weight: 600;
  font-size: 16px;

  .v-icon {
    color: $color-neutral-90 !important;
  }
}

.v-list-item {
  padding: 12px 16px;

  &:hover {
    background: #f6f6f6;
  }

  &-action {
    color: $accent;
    font-weight: 600;
  }
}
</style>
